<script setup lang="ts">
import NavbarTop from './NavbarTop.vue'
import NavbarMain from './NavbarMain.vue'
</script>

<template>
    <header class="relative">
        <nav aria-label="Top">
            <NavbarTop />
            <NavbarMain />
        </nav>
    </header>
</template>
